'use client'

import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useMediaQuery } from '@cocoonspace/shared/hooks/use-media-query.hook'
import { cn } from '@cocoonspace/ui/lib/utils'
import { AnimatePresence } from 'motion/react'

// import { StickyContentFooter } from '~/components/atoms/sticky-content-footer'
import { ResizablePanel } from '~/components/molecules/resizable-panel'
import { Infobox } from '~/domains/booking/components/molecules/infobox'
import { BookingStepper } from './booking-stepper'

export const SpaceDetailsSidebar = ({
	space,
	showInfoCard,
}: {
	space: Space
	showInfoCard?: boolean
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)')
	const isTablet = useMediaQuery('(min-width: 768px)')

	const isInfoCardVisible = !isMobile || (isMobile && showInfoCard)
	const bookingPanelClassName = cn(
		'border-border relative order-2 touch-none overflow-hidden rounded-lg border bg-white max-md:rounded-b-none max-md:border-b-0 md:order-1',
		{ 'min-h-[260px]': isTablet },
	)

	return (
		<div className='flex flex-col max-md:fixed max-md:inset-x-0 max-md:bottom-0 max-md:z-50 max-md:shadow-lg md:sticky md:top-[calc(var(--app-navbar-height)+60px)] md:gap-y-4'>
			<ResizablePanel
				className={bookingPanelClassName}
				shouldResize={!isMobile}
			>
				<BookingStepper space={space} />
			</ResizablePanel>

			<AnimatePresence>
				{isInfoCardVisible && <Infobox space={space} />}
			</AnimatePresence>
		</div>
		// <StickyContentFooter className='flex flex-col md:sticky md:top-[calc(var(--app-navbar-height)+60px)] md:gap-y-4'>
		// 	<ResizablePanel
		// 		className={bookingPanelClassName}
		// 		shouldResize={!isMobile}
		// 	>
		// 		<BookingStepper space={space} />
		// 	</ResizablePanel>

		// 	<AnimatePresence>
		// 		{isInfoCardVisible && <Infobox space={space} />}
		// 	</AnimatePresence>
		// </StickyContentFooter>
	)
}
